import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { FieldFooter } from '../FieldFooter';
import { Checkbox, CheckboxLabel, Wrapper } from './Checkbox.styles';
export const CheckboxInput = /*#__PURE__*/ forwardRef(({ 'data-testid': dataTestId, hasBoldLabel, hasError, isDisabled, label, labelSlot, name, statusLabel, value, ...props }, ref)=>{
    const id = value ? `${name}_${value}` : name;
    return /*#__PURE__*/ _jsxs(Wrapper, {
        "data-testid": dataTestId,
        children: [
            /*#__PURE__*/ _jsx(Checkbox, {
                disabled: isDisabled,
                id: id,
                name: name,
                value: value,
                ...props,
                $state: hasError ? 'error' : isDisabled ? 'disabled' : 'default',
                ref: ref
            }),
            /*#__PURE__*/ _jsxs(CheckboxLabel, {
                $isDisabled: isDisabled,
                htmlFor: id,
                isBold: hasBoldLabel,
                children: [
                    label ?? labelSlot,
                    /*#__PURE__*/ _jsx(FieldFooter, {
                        fieldFooterLabel: statusLabel,
                        fieldFooterType: hasError ? 'error' : 'default'
                    })
                ]
            })
        ]
    });
});

//# sourceMappingURL=CheckboxInput.js.map